import React from 'react';

const InputCadastroComIcone = ({
  id,
  className,
  campoClassName,
  iconName,
  name,
  label,
  inputRef,
  errors,
  control,
  watch,
  legenda,
  ...rest
}) => {
  const msgErro = errors && errors[name]?.message;
  return (
    <div className={`campo-txt ${msgErro ? 'erro' : ''} ${campoClassName ? campoClassName : ''}`}>
      <label className={`subtitulo-p`} htmlFor={id}>
        {label}
      </label>
      <div className="input-container input-com-ic">
        <i className={`${iconName} input-ic`}></i>
        <input
          type={'text'}
          id={id}
          name={name}
          ref={inputRef}
          className={msgErro ? 'invalid' : ''}
          {...rest}
        />
      </div>
      <div className="mensagem legenda">{msgErro}</div>
    </div>
  );
};

export default InputCadastroComIcone;
